import PlatformList from './platform-list.container';

export default PlatformList;
